module.exports = __webpack_public_path__ + "img/bus_nagoya.aa74a68e.jpg";